var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.907,
    height: 19.469,
    viewBox: "0 0 21.907 19.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-edit",
    "data-name": "Icon awesome-edit",
    d: "M15.312,3.168,18.742,6.6a.372.372,0,0,1,0,.525l-8.306,8.306-3.529.392A.74.74,0,0,1,6.089,15l.392-3.529,8.306-8.306A.372.372,0,0,1,15.312,3.168ZM21.473,2.3,19.617.441a1.487,1.487,0,0,0-2.1,0L16.171,1.787a.372.372,0,0,0,0,.525L19.6,5.742a.372.372,0,0,0,.525,0L21.473,4.4a1.487,1.487,0,0,0,0-2.1ZM14.6,13.17v3.872H2.434V4.871h8.74a.468.468,0,0,0,.323-.133l1.521-1.521a.456.456,0,0,0-.323-.78H1.826A1.826,1.826,0,0,0,0,4.263V17.65a1.826,1.826,0,0,0,1.826,1.826H15.213a1.826,1.826,0,0,0,1.826-1.826v-6a.457.457,0,0,0-.78-.323l-1.521,1.521A.468.468,0,0,0,14.6,13.17Z",
    transform: "translate(0 -0.007)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceEditIcon);
export default __webpack_public_path__ + "static/media/service_edit_icon.019f940f4abd2f3c884d2b6dc0e82556.svg";
export { ForwardRef as ReactComponent };